import { asset1, asset2, asset3, asset4 } from './assets'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 'dieCast', position: 'Right' },
  // { src: asset2, x: 87.7076, y: 131.4871, overlay: true },
  { src: asset3, x: 897.9909, y: 0, itemId: 'dieCast', position: 'Left' },
  // { src: asset4, x: 973.5179, y: 131.4871, overlay: true },
]

const data = {
  assets: assets,
}

export default data
